export const additionalChargesTab = {
  loading: "Caricamento delle impostazioni…",
  tax: {
    title: "Imposta (IVA)",
    tag: "Inclusa nel prezzo",
    description:
      "L'IVA è già <b>inclusa</b> nei prezzi delle tue tariffe. Qui imposti solo la percentuale da scorporare su ricevuta e fattura — <b>non viene aggiunta al totale</b>.",
    hint: "Vuoto = viene usata l'IVA dell'emittente di fatturazione assegnato. Si applica solo alle prenotazioni dirette.",
  },
  cleaning: {
    title: "Spese di pulizia",
    tag: "Fisso",
    description: "Importo fisso per soggiorno. Se <b>0</b>, non viene applicato.",
    showToGuest: "Mostra nel riepilogo della prenotazione",
  },
  charges: {
    title: "Costi aggiuntivi",
    summary: "{count} costo configurato. | {count} costi configurati.",
    summaryEmpty: "Crea costi opzionali (per prenotazione, per persona o per notte).",
    addButton: "Aggiungi costo",
    empty: "Nessun costo aggiuntivo per ora.",
    headers: {
      title: "Titolo",
      method: "Come viene addebitato",
      value: "Valore",
      visible: "Visibile",
    },
    titlePlaceholder: "es. Tassa di soggiorno",
    removeTitle: "Elimina",
    hint: "I costi visibili vengono mostrati all'ospite come voce separata al momento del pagamento; gli altri vengono aggiunti al totale.",
  },
  methods: {
    perStay: "Importo per prenotazione",
    perNight: "Importo per notte",
    perPerson: "Importo per persona",
    perPersonPerNight: "Importo per persona per notte",
    percent: "% del totale della prenotazione",
  },
  validation: {
    cleaningInvalid: "Le spese di pulizia devono essere un numero valido e positivo.",
    taxRange: "L'IVA deve essere compresa tra 0 e 100%.",
    chargeTitleRequired: "Ogni costo aggiuntivo deve avere un titolo.",
    chargeValueInvalid: 'Il valore del costo "{title}" non è valido.',
    chargePercentMax: 'La percentuale del costo "{title}" non può superare il 100%.',
  },
  toasts: {
    saveSuccess: "Costi aggiuntivi salvati con successo.",
    saveError: "Impossibile salvare i costi aggiuntivi.",
  },
};
